import { FormattedMessage } from 'react-intl';
import React, { useContext } from 'react';
import { Row, Col, Divider } from 'antd';
import myContext from '@/utils/createContext';

function LockLoading(props) {
  const { msg } = props;
  return (
    <div className="celerpay-checkout">
      <div className="preloader spinner">
        <div className="spinWrap">
          <p className="spinnerImage"></p>
          <p className="loader"></p>
          {msg ? <p className="loadingMessage">Processing...</p> : null}
        </div>
      </div>
    </div>
  );
}

export default LockLoading;
